import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterOutlet } from '@angular/router';
import { I18nService } from '@itavan/lib/core/services';

@Component({
  selector: 'app-layout-logout',
  imports: [RouterOutlet, MatButtonModule, MatIconModule, MatMenuModule],
  template: `
    <div class="min-h-screen flex justify-center">
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>

      <!-- Language Switcher -->
      <div class="fixed top-0 left-0 right-0 z-50 h-16 md:h-20 pointer-events-none bg-primary">
        <div class="max-w-md mx-auto h-full flex justify-end items-center px-4 sm:px-6 lg:px-8">
          <div
            [matMenuTriggerFor]="langMenu"
            class="pointer-events-auto flex items-center gap-1.5 cursor-pointer text-light/60 hover:text-light transition-colors"
            role="button"
          >
            <span class="text-sm font-medium">{{ langNames[i18n.getActiveLang()] }}</span>
            <mat-icon inline="true" class="!text-[20px] !leading-none">language</mat-icon>
          </div>
        </div>
      </div>

      <mat-menu #langMenu="matMenu">
        <button mat-menu-item (click)="i18n.setLanguage('es')">
          <div class="flex flex-row">
            <div class="text-lg leading-none">
              <mat-icon
                [inline]="true"
                class="!size-[18px]"
                [class.invisible]="i18n.getActiveLang() !== 'es'"
                >check</mat-icon
              >
            </div>
            Español
          </div>
        </button>
        <button mat-menu-item (click)="i18n.setLanguage('en')">
          <div class="flex flex-row">
            <div class="text-lg leading-none">
              <mat-icon
                [inline]="true"
                class="!size-[18px]"
                [class.invisible]="i18n.getActiveLang() !== 'en'"
                >check</mat-icon
              >
            </div>
            English
          </div>
        </button>
        <button mat-menu-item (click)="i18n.setLanguage('pt')">
          <div class="flex flex-row">
            <div class="text-lg leading-none">
              <mat-icon
                [inline]="true"
                class="!size-[18px]"
                [class.invisible]="i18n.getActiveLang() !== 'pt'"
                >check</mat-icon
              >
            </div>
            Português
          </div>
        </button>
      </mat-menu>
    </div>
  `,
  styles: ``,
})
export class LayoutLogout {
  public i18n = inject(I18nService);

  readonly langNames: Record<string, string> = {
    es: 'Español',
    en: 'English',
    pt: 'Português',
  };
}
